import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import AdditionalOptions from './AdditionalOptions';

export default styled(AdditionalOptions)`
  .label {
    color: var(--grey700);
    margin: 0;
  }

  .comments {
    margin: ${gridSizes('XS')} 0 0 0;
    font-style: italic;
    color: var(--grey700);
    overflow: hidden;
  }

  h3 {
    font-weight: 500;
    font-size: 2.4rem;
    margin: ${gridSizes('M')} 0;
  }

  &.small {
    h3 {
      font-size: 1.8rem;
      margin: ${gridSizes('S')} 0;
      color: var(--grey800);
    }
  }
`;
